import {uiPalette} from "./uiTokens"

export const colors = {
    light: {
        colorPrimary: uiPalette.brand,
        colorLink: uiPalette.brand,
        bgSecondaryPrimary: "#F4F6F8",
        bgContainerColor: "#ffffff",
        colorBorder: "#D8DEE8"
    },
    dark: {
        colorPrimary: uiPalette.brand,
        colorLink: "#B69CFF",
        bgSecondaryPrimary: "#111318",
        bgContainerColor: "#181B22",
        colorBorder: "#303641"
    }
}
